<template>
  <div class="agreement-list-page">
    <div class="list-wrap">
      <van-loading v-if="loading" class="loading-center" size="24px" vertical>加载中...</van-loading>
      <van-empty v-else-if="!list.length" description="暂无协议" />
      <div v-else class="list-inner">
        <div
          v-for="(item, index) in list"
          :key="agreementKey(item, index)"
          class="agreement-item"
          @click="onItemClick(item)"
        >
          <div class="item-icon">
            <van-icon name="description" />
          </div>
          <div class="item-main">
            <div class="item-title">{{ agreementTitle(item) }}</div>
          </div>
          <div
            class="item-status"
            :class="{ done: agreementDone(item) }"
          >{{ agreementDone(item) ? '已完成' : '未完成' }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { NavBar, Icon, Loading, Empty, Toast } from 'vant'
import {
  getBMMatchTeamAgreements,
  getBMMatchTeamPlayerAgreements
} from '@/api/match'

Vue.use(NavBar).use(Icon).use(Loading).use(Empty).use(Toast)

export default {
  name: 'AgreementList',
  data() {
    return {
      loading: true,
      list: [],
      listType: 'leader',
      matchId: '',
      teamId: '',
      unionMatchId: '',
      playerId: ''
    }
  },
  computed: {
    pageTitle() {
      return this.listType === 'player' ? '队员协议' : '领队协议'
    },
    isPlayer() {
      return this.listType === 'player'
    }
  },
  mounted() {
    const q = this.$route.query || {}
    const t = (q.type || 'leader').toString().toLowerCase()
    // type: leader | captain | teamLeader → 领队；player | member → 队员
    if (t === 'player' || t === 'member') this.listType = 'player'
    else this.listType = 'leader'
    this.matchId = q.matchId || ''
    this.teamId = q.teamId || ''
    this.unionMatchId = q.unionMatchId || ''
    this.playerId = q.playerId || ''
    this.fetchList()
  },
  methods: {
    onBack() {
      if (window.history.length > 1) {
        this.$router.back()
        return
      }
      const q = {
        unionMatchId: this.unionMatchId,
        matchId: this.matchId,
        teamId: this.teamId
      }
      if (this.isPlayer && this.playerId) {
        q.playerId = this.playerId
      }
      this.$router.replace({
        path: this.isPlayer ? '/entry-page/entry-info-player' : '/entry-page/entry-info',
        query: q
      })
    },
    agreementKey(item, index) {
      return item.id != null ? item.id : item.agreementId != null ? item.agreementId : index
    },
    agreementTitle(item) {
      if (!item) return '-'
      return item.title || item.agreementTitle || item.name || '-'
    },
    /** confirmed：0 未完成，1 已完成 */
    agreementDone(item) {
      if (!item) return false
      return Number(item.confirmed) === 1
    },
    normalizeList(payload) {
      if (!payload) return []
      if (Array.isArray(payload)) return payload
      if (Array.isArray(payload.list)) return payload.list
      if (Array.isArray(payload.agreements)) return payload.agreements
      return []
    },
    fetchList() {
      if (!this.matchId || !this.teamId) {
        this.loading = false
        Toast.fail('缺少赛事或球队参数')
        return
      }
      if (this.isPlayer && !this.playerId) {
        this.loading = false
        Toast.fail('缺少队员参数')
        return
      }
      const base = {
        matchId: this.matchId,
        teamId: this.teamId
      }
      const req = this.isPlayer
        ? getBMMatchTeamPlayerAgreements({ ...base, playerId: this.playerId })
        : getBMMatchTeamAgreements(base)
      this.loading = true
      req
        .then(res => {
          if (!res) {
            this.list = []
            return
          }
          const data = res.data || {}
          this.list = this.normalizeList(data)
        })
        .finally(() => {
          this.loading = false
        })
    },
    onItemClick(item) {
      const id = item.id != null ? item.id : item.agreementId
      if (id == null) {
        Toast('协议信息不完整')
        return
      }
      this.$router.push({
        path: '/entry-page/agreement-confirm',
        query: {
          type: this.isPlayer ? 'player' : 'leader',
          unionMatchId: this.unionMatchId,
          matchId: this.matchId,
          teamId: this.teamId,
          agreementId: id,
          ...(this.isPlayer && this.playerId ? { playerId: this.playerId } : {})
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.agreement-list-page {
  min-height: 100vh;
  background: #f5f6f7;
  box-sizing: border-box;
  padding-bottom: 24px;
}

.list-wrap {
  padding: 12px 14px 0;
}

.loading-center {
  padding: 48px 0;
  display: flex;
  justify-content: center;
}

.list-inner {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.agreement-item {
  display: flex;
  align-items: center;
  background: #fff;
  border-radius: 10px;
  padding: 0 12px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
  height: 55px;
  box-sizing: border-box;
}

.item-icon {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: linear-gradient(135deg, #509dea 0%, #3b7dd8 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 20px;
}

.item-main {
  flex: 1;
  min-width: 0;
  margin-left: 12px;
}

.item-title {
  font-size: 15px;
  font-weight: 500;
  color: #303133;
  line-height: 1.4;
  word-break: break-all;
}

.item-status {
  flex-shrink: 0;
  font-size: 14px;
  color: #909399;
  margin-left: 8px;

  &.done {
    color: #07c160;
  }
}
</style>
